
export enum CustomerDetailCd {
	ACCOUNT = 'Account',
	ALIAS = 'Alias',
	CONTACT = 'Contact',
	INVOICE_INSTRUCTIONS = 'InvoiceInstructions'}

